// extracted by mini-css-extract-plugin
export default {"content":"RichTextDisplay_content__eRhCP"};